/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonERP } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getFlujoTesoreriaReadingFiltersDtoIPagedEnumerableParamsProps } from "api/FlujoTesoreria.service"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import SwitchButtons from "common/components/SwitchButtons"
import { AnimatePresence, motion } from "framer-motion"
import { Skeleton } from "primereact/skeleton"
import { Dispatch, SetStateAction, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { switchButtons } from "../constants/constants"

export const FilterMenu = ({
  serviceQuery,
  sortingCriteria,
  skipCount,
  maxResultCount,
  isLoading,
  totalCount,
  showDeleteMultipleButton,
  showDeleteMultipleArticulosModal,
  downloadExcel,
  isDownloadingExcel,
  setShowWithGrid,
  setShowArticuloModal,
  categoriasItemsRefetch,
}: {
  serviceQuery: (
    queryParams: getFlujoTesoreriaReadingFiltersDtoIPagedEnumerableParamsProps
  ) => void
  sortingCriteria?: SortingCriteria
  skipCount?: getFlujoTesoreriaReadingFiltersDtoIPagedEnumerableParamsProps["SkipCount"]
  maxResultCount?: getFlujoTesoreriaReadingFiltersDtoIPagedEnumerableParamsProps["MaxResultCount"]
  isLoading?: boolean
  totalCount: number
  showDeleteMultipleButton: boolean
  showDeleteMultipleArticulosModal: () => void
  downloadExcel: () => void
  isDownloadingExcel: boolean
  setShowWithGrid: Dispatch<SetStateAction<boolean>>
  setShowArticuloModal: Dispatch<
    SetStateAction<{
      show: boolean
      isEdit: boolean
    }>
  >
  categoriasItemsRefetch: () => void
}) => {
  const { t } = useTranslation()

  const queryFixer = (
    queryParams: getFlujoTesoreriaReadingFiltersDtoIPagedEnumerableParamsProps
  ) => {
    const articulosParams = {
      MaxResultCount: queryParams.MaxResultCount,
      SkipCount: queryParams.SkipCount,
      SortingCriteria:
        queryParams.SortingCriteria?.property &&
        queryParams.SortingCriteria?.sort
          ? `${queryParams.SortingCriteria.property} ${queryParams.SortingCriteria.sort}`
          : "CreationTime DESC",
    }
    const fixedQueryParams = Object.fromEntries(
      Object.entries(articulosParams).filter(
        ([_key, value]) => value || value === 0 // eslint-disable-line @typescript-eslint/no-unused-vars
      )
    )
    return fixedQueryParams
  }
  const query = {
    SortingCriteria: sortingCriteria,
    SkipCount: skipCount,
    MaxResultCount: maxResultCount,
  }
  const handleQuery = () => {
    serviceQuery(queryFixer(query))
  }

  useEffect(() => {
    handleQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    skipCount,
    maxResultCount,
    sortingCriteria?.sort,
    sortingCriteria?.property,
  ])

  return (
    <>
      <div className='!tw-px-8 tw-flex tw-flex-col xl:tw-flex-row tw-justify-between tw-items-center tw-pb-4 tw-pt-6 tw-shadow-3xl tw-rounded-t-xl mb-1'>
        <p className='tw-text-xl tw-font-normal tw-flex tw-items-center tw-text-nowrap'>
          {t("inventario.articulos.title")} (
          {isLoading ? (
            <Skeleton className='!tw-h-5 !tw-w-8 !tw-mx-1' />
          ) : (
            <span>{totalCount}</span>
          )}
          )
        </p>
        <div className='tw-gap-3 tw-flex tw-items-center'>
          <AnimatePresence>
            {showDeleteMultipleButton && (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0 }}
                title='Eliminar artículos'
              >
                <ButtonERP
                  onClick={showDeleteMultipleArticulosModal}
                  customize={{
                    type: "danger",
                    size: "md",
                  }}
                  icon={<FontAwesomeIcon icon={["fal", "trash-can"]} />}
                />
              </motion.div>
            )}
          </AnimatePresence>

          <ButtonERP
            label={`${t("inventario.articulos.exportButton")}`}
            onClick={downloadExcel}
            loading={isDownloadingExcel}
            customize={{
              type: "white",
              size: "md",
            }}
          />
          <ButtonERP
            label={`${t("inventario.articulos.newButton")}`}
            onClick={() => {
              categoriasItemsRefetch()
              setShowArticuloModal({ show: true, isEdit: false })
            }}
            customize={{
              type: "secondary",
              size: "md",
            }}
          />

          <SwitchButtons
            btns={switchButtons(t)}
            onSelect={({ id }: { id: string }) => {
              setShowWithGrid(id === "GRID")
            }}
          />
        </div>
      </div>
    </>
  )
}
